import { ReactNode } from "react";
import { cn } from "@/lib/utils";

type PortalContentWidth = "default" | "wide" | "narrow" | "full";

interface PortalContentProps {
  children: ReactNode;
  width?: PortalContentWidth;
  className?: string;
}

const widthClassMap: Record<PortalContentWidth, string> = {
  default: "max-w-screen-2xl",
  wide: "max-w-[1800px]",
  narrow: "max-w-5xl",
  full: "",
};

/**
 * PortalContent — shared content wrapper for portal pages.
 *
 * Provides consistent horizontal gutters and a sensible max-width so dashboards
 * do not stretch edge-to-edge on ultra-wide monitors. Compose inside the
 * existing PortalLayout / AdminPortalShell main areas — does not replace them.
 */
export default function PortalContent({
  children,
  width = "default",
  className,
}: PortalContentProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full px-4 md:px-6 lg:px-8",
        widthClassMap[width],
        className,
      )}
    >
      {children}
    </div>
  );
}
